import React, { useState } from 'react';
import { Phone, Mail, SquareArrowUpRightIcon } from 'lucide-react';
import caroline from "./img/CM - Headshot.jpg";
import kb from "./img/KB - Headshot.jpg";
import habib from "./img/Habib - Head Shot.jpg";
import vanessa from "./img/chosenheadshot.jpg";
import pj from "./img/PJ - Headshot.jpg";
import miamarie from "./img/MiaMarie Headshot.png"

const Attorneys = () => {
  const [selectedAttorney, setSelectedAttorney] = useState(null);

  const attorneys = [
    { 
      name: 'Kenneth W. Brown, AICP', 
      title: 'SHAREHOLDER', 
      img: kb,
      bio: 'Kenneth Brown is a shareholder of Brown & McDonald, PLLC, focusing on municipal land use planning and zoning matters in San Antonio and South Texas,  with a particular emphasis on zoning and land use issues that affect abutting properties and neighborhoods, as well as traffic and environmental concerns. In addition to his professional practice, Ken is a former Adjunct Professor at the University of Texas at San Antonio Graduate Program of Public Policy, where he taught Planning and Land Use Law. He currently serves on the City of San Antonio Planning Commission Technical Advisory Committee.',
      phone: '210.429.7907',
      email: 'ken@brownmcdonaldlaw.com',
      linkedin: 'https://www.linkedin.com/in/ken-brown-4727773b',
      education: ["St. Mary’s University School of Law, J.D.", "University of Texas at Austin, M.S., Community and Regional Planning", "University of Texas at Austin, B.S., Education"],
      memberships: ["San Antonio and Texas Bar Associations", "American Institute of Certified Planners", "American Planning Association, Texas Chapter of Planning and Law Division, Vice President, 1994", "Bexar County Housing Authority, Commissioner, 1997-2002", "UTSA COPP Advisory Council", "COSA Unified Development Code Oversight Committee", "COSA Planning Commission Technical Advisory Committee"]
    },
    { 
      name: 'Caroline McDonald',
      title: 'SHAREHOLDER', 
      img: caroline,
      bio: 'Caroline McDonald is the majority shareholder of Brown & McDonald, PLLC, and she possesses extensive knowledge of environmental, economic development, land use planning, zoning, and utility law in San Antonio and the greater Bexar County areas. Before joining the firm, McDonald served as a partner at a mid-sized law firm in San Antonio, where she worked for eight years. Throughout her tenure, she demonstrated repeated success for her clients in all scenarios, from small neighborhood rezoning to securing various land entitlements and economic incentives such as the creation of tax increment reinvestment zones (TIRZ) or Public Improvement Districts (PID). Caroline has represented non-profits, small businesses, commercial, industrial, and residential real estate developers, as well as multinational corporations in front of municipalities, County Commissioner Courts, and State administrative agencies, such as the Public Utility Commission (PUC) and the Texas Commission on Environmental Quality (TCEQ).',
      phone: '210.429.7901',
      email: 'caroline@brownmcdonaldlaw.com',
      linkedin: 'https://www.linkedin.com/in/caroline-mcdonald-293851127',
      education: ['Texas Tech University, School of Law, J.D.', 'Texas Tech University, B.A., History'],
      memberships: ['San Antonio Bar Association Environmental Law Section, President', 'Urban Land Institute Mentorship Program Class, 2017', 'Real Estate Council of San Antonio Leadership Class, 2016', 'Junior League of San Antonio, 2016-2019', 'Texas State Bar Association', 'San Antonio Bar Association', 'San Antonio Young Lawyers Association', "Bexar County Women’s Bar Association"]
    },
    { 
      name: 'MiaMarie Pugh', 
      title: 'ASSOCIATE ATTORNEY', 
      img: miamarie,
      bio: "MiaMarie Pugh is a passionate and dedicated lawyer who joined the firm in 2023. She graduated from Texas A&M University with a BS in Environmental Studies, where she developed a keen interest in policy and regulation. She pursued two internships that played a pivotal role in her decision to study law: the Mickey Leland Environmental Internship Program with the Texas Commission on Environmental Quality (TCEQ), which she participated in for two summers, and an internship at the Texas State Capitol, where she gained valuable insight into the legislative process. She earned her JD from St. Mary’s University School of Law, where she completed her third Mickey Leland Environmental Internship with the TCEQ. Prior to joining the firm, she worked as an Assistant City Attorney for the City of Houston, where she focused her practice on environmental regulatory compliance issues, real estate transactions, and tracking 88th Legislative Session.",
      phone: '210.429.7917',
      email: 'miamarie@brownmcdonaldlaw.com',
      linkedin: 'https://www.linkedin.com/in/miamarie-pugh',
      education: ["St. Mary's University School of Law, JD", "Texas A&M University, B.S., Environmental Studies"],
      memberships: ["Texas State Bar Association", "San Antonio Bar Association", "Texas Aggie Bar Association", "Houston Bar Association"]
    },
    { 
      name: 'Venessa Rodriguez', 
      title: 'ASSOCIATE ATTORNEY', 
      img: vanessa,
      bio: "Venessa Rodriguez has jumped back into practicing law after managing a household for three years and joined the firm as a Senior Associate in 2024. She earned her JD from Texas Tech School of Law and began taking Bexar County criminal court appointments as soon as she passed the bar. Over the course of her career, she transitioned from criminal law to real estate law as she served as the attorney for her husband’s construction company, and they began building homes in San Antonio.  With eleven years of legal experience, she has successfully represented clients in criminal cases, conducted compliance review for a national bank, represented buyers and sellers in real estate, executed title searches, and has managed the planning and permitting stage of residential projects. Prior to joining the firm, she worked as an Assistant City Attorney for the City of San Antonio, where she focused her practice on Tax Increment Financing and other economic development projects. During her legal career she has been honored to present at CLE courses on topics ranging from criminal defense to economic incentives. When not at the office you can find her running on the greenway trails or spending quality time with her husband and three children.",
      phone: '210.412.6494',
      email: 'venessa@brownmcdonaldlaw.com',
      linkedin: 'https://www.linkedin.com/in/venessa-rodriguez-2733b330',
      education: ["Juris Doctor (J.D.), Texas Tech School of Law", "Bachelor of Business Administration (B.B.A.) Marketing, Texas Tech University"],
    },
    { 
      name: 'Paul Jaurez', 
      title: 'OF COUNSEL', 
      img: pj,
      bio: "Paul practices in municipal land use and real estate transaction areas in San Antonio and Austin. Experienced with managing development projects through municipal and county development processes. Paul’s practice emphasizes in real estate transactions, from due diligence and acquisition to entitlement and construction. Paul has worked on numerous developments of single family, multi-family, retail, commercial and mixed-used developments. His most recent project was supervision of the development and construction of a multi-phased commercial development in Austin, Texas.",
      phone: '210.429.7875',
      email: 'paul@brownmcdonaldlaw.com',
      linkedin: 'https://www.linkedin.com/in/paul-juarez-307a871',
      education: ["The University of Texas, School of Law, Austin, Texas, J.D.", "The University of Texas at Austin, Graduate school of Business, Texas, M.B.A", "Texas A&M Corpus Christi, B.S., Political Science"],
      memberships: ["Travis County Bar Association", "Texas Bar Association"]
    },
    { 
      name: 'Habib H. Erkan, Jr.', 
      title: 'OF COUNSEL', 
      img: habib,
      bio: 'For more than thirty years Habib has served private, municipal, and various local government clients throughout central and south Texas. Throughout his career Habib’s knowledge and experience have assisted clients in achieving desired outcomes related to economic incentives, development entitlements, zoning, real estate transactions, annexation, and other local government issues.',
      phone: '210.445.4164',
      email: 'habiberkan@live.com',
      linkedin: 'https://www.linkedin.com/in/habib-erkan-8b454b16',
      education: ["St. Mary’s University School of Law, JD", "The University of Houston Clear Lake, B.S., Behavioral Science"],
      memberships: ["Texas Bar Association", "Texas City Attorneys Association"]
    },
  ];

  const handleAttorneyClick = (attorney) => {
    setSelectedAttorney(selectedAttorney === attorney ? null : attorney);
  };

  return (
    <section id="attorneys" className="py-24 bg-white relative">
      <div className="container mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-playfair text-green-700 mb-12 text-center">
          Our Team
        </h2>
        {/* Grid: 1 col on mobile, 2 on md, 3 on lg */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {attorneys.map((attorney, index) => (
            <div key={index} className="group cursor-pointer">
              {/* Square container on larger screens */}
              <div 
                className="relative overflow-hidden rounded-lg shadow-lg mb-4 aspect-square"
                onClick={() => handleAttorneyClick(attorney)}
              >
                {/* Hover overlay */}
                <div className="absolute inset-0 bg-blue-800 opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>
                {/* Headshot as a square */}
                <img
                  src={attorney.img}
                  alt={attorney.name}
                  className="w-full h-full object-cover object-center"
                />
              </div>
              <h3 className="text-xl font-playfair text-green-700">{attorney.name}</h3>
              <p className="text-blue-800">{attorney.title}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Bio Overlay */}
      {selectedAttorney && (
        <div
          className="fixed inset-0 bg-black bg-opacity-80 z-50 flex items-start justify-center p-4 overflow-y-auto"
          onClick={() => setSelectedAttorney(null)}
        >
          <div
            className="bg-green-700 rounded-lg max-w-3xl w-full p-6 relative mt-10 mb-10"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="absolute top-4 right-4 text-2xl text-white hover:text-gray-200 z-10"
              onClick={() => setSelectedAttorney(null)}
            >
              &times;
            </button>

            {/* Modal Content */}
            <div className="flex flex-col md:flex-row items-start">
              {/* Left Column: Basic Info & Photo */}
              <div className="flex flex-col items-center w-full md:w-auto mb-4 md:mb-0 md:mr-8">
                <h3 className="text-2xl font-playfair text-white mb-2">
                  {selectedAttorney.name}
                </h3>
                {/* Square headshot in modal for non-mobile */}
                <img
                  src={selectedAttorney.img}
                  alt={selectedAttorney.name}
                  className="w-48 h-48 object-cover object-center rounded-lg mb-4"
                />
                {/* Contact Info */}
                <div className="flex flex-col space-y-2 w-full items-left md:items-start">
                  {selectedAttorney.phone && (
                    <a
                      href={`tel:${selectedAttorney.phone.replace(/\D/g, '')}`}
                      className="text-sm text-white hover:text-blue-600 flex items-center"
                    >
                      <Phone className="mr-2" size={13} />
                      {selectedAttorney.phone}
                    </a>
                  )}
                  {selectedAttorney.email && (
                    <a
                      href={`mailto:${selectedAttorney.email}`}
                      className="text-sm text-white hover:text-blue-600 flex items-center"
                    >
                      <Mail className="mr-2" size={13} />
                      {selectedAttorney.email}
                    </a>
                  )}
                  {selectedAttorney.linkedin && (
                    <a
                      href={selectedAttorney.linkedin}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-sm text-white hover:text-blue-600 flex items-center"
                    >
                      <SquareArrowUpRightIcon className="mr-2" size={13} />
                      LinkedIn
                    </a>
                  )}
                </div>

                {/* Education */}
                {selectedAttorney.education?.length > 0 && (
                  <div className="w-full mt-4">
                    <p className="text-lg text-white mb-2">EDUCATION</p>
                    <ul className="list-disc list-outside pl-5">
                      {selectedAttorney.education.map((edu, idx) => (
                        <li key={idx} className="text-sm text-gray-200 text-justify">
                          {edu}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

                {/* Memberships */}
                {selectedAttorney.memberships?.length > 0 && (
                  <div className="w-full mt-4">
                    <p className="text-lg text-white mb-2">
                      ASSOCIATIONS & MEMBERSHIPS
                    </p>
                    <ul className="list-disc list-outside pl-5">
                      {selectedAttorney.memberships.map((m, idx) => (
                        <li key={idx} className="text-sm text-gray-200 text-justify">
                          {m}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>

              {/* Right Column: Title + Bio */}
              <div className="flex-grow">
                <p className="text-white mb-4 text-lg">
                  {selectedAttorney.title}
                </p>
                <p className="text-gray-200 text-justify">{selectedAttorney.bio}</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Attorneys;